// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import VueI18n from 'vue-i18n'
import Buefy from 'buefy'
import '../node_modules/tui-calendar/dist/tui-calendar.css'
import store from './store'
import sanitizeHTML from 'sanitize-html'
import VueCharts from 'vue-chartjs'
import Vue2TouchEvents from 'vue2-touch-events'
import VueLazyload from 'vue-lazyload'
import VueAnalytics from 'vue-analytics'
import Unsplash from 'unsplash-js'
import axios from 'axios'
import VueHead from 'vue-head'
import VS2 from 'vue-script2'
import Croppa from 'vue-croppa'
import 'vue-croppa/dist/vue-croppa.css'
import VueMeta from 'vue-meta'
import vueSmoothScroll from 'vue2-smooth-scroll'
import VueQuillEditor from 'vue-quill-editor'
import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import 'quill/dist/quill.bubble.css'
import { library } from '@fortawesome/fontawesome-svg-core'
import { fas } from '@fortawesome/free-solid-svg-icons'
import { far } from '@fortawesome/free-regular-svg-icons'
import { fab } from '@fortawesome/free-brands-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import _ from 'lodash'
import moment from 'moment'
import PortalVue from 'portal-vue'
import VueSelect from 'vue-select'
import 'vue-select/dist/vue-select.css';
import * as Sentry from "@sentry/vue";

Vue.prototype.$sanitize = sanitizeHTML
Vue.config.productionTip = false
Vue.use(Buefy)
Vue.use(VueI18n)
Vue.use(VueCharts)
Vue.use(Vue2TouchEvents)
Vue.use(vueSmoothScroll)
Vue.use(VueMeta)
Vue.use(VueHead)
Vue.use(VS2)
Vue.use(Croppa)
Vue.use(VueLazyload, {
  preLoad: 1.3,
  error: require('./assets/lazy_img.svg'),
  loading: require('./assets/lazy_img.svg'),
  attempt: 1
})
Vue.use(VueAnalytics, {
  id: ['UA-141589617-1', 'UA-141589617-2'],
  router
})
Vue.use(VueQuillEditor)

library.add(fas, far, fab)
Vue.component('font-awesome-icon', FontAwesomeIcon)

Vue.use(PortalVue)
Vue.component('v-select', VueSelect)

if (process.env.NODE_ENV === 'production' || process.env.NODE_ENV === 'third') {
  window.console = {}
  window.console.log = function (i) { return 0 }
  window.console.error = function (i) { return 0 }
  window.console.time = function (i) { return 0 }
  window.console.timeEnd = function (i) { return 0 }
  window.console.debug = function (i) { return 0 }
  window.console.info = function (i) { return 0 }
  window.console.warn = function (i) { return 0 }
}

const i18n = new VueI18n({
  locale: navigator.language,
  fallbackLocale: 'ja',
  messages: {
    en: require('./localizable/en.json'),
    ja: require('./localizable/ja.json')
  }
})

const unsplash = new Unsplash({
  applicationId: process.env.UNSPLASH_KEY,
  secret: process.env.UNSPLASH_SEC
})
Vue.prototype.$unsplash = unsplash
Vue.prototype.$axios = axios
Vue.prototype.$moment = moment
Vue.prototype.$isUser = () => {
  return localStorage.getItem('IS_USER') == 'true'
}
Vue.prototype.$isClient = () => {
  return localStorage.getItem('IS_CLIENT') == 'true'
}
// chatbot自動再生ボタンのオンオフ
Vue.prototype.$clickAutoBtn = (bool) => {
  store.dispatch('chatbot/clickAutoBtn', bool)
}
Object.defineProperty(Vue.prototype, '$_', { value: _ })

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  i18n: i18n,
  components: { App },
  template: '<App/>'
});

// Sentryの初期化
Sentry.init({
  Vue,  // Vue 2
  dsn: process.env.SENTRY_DSN,  // 環境変数から取得
  // integrations: [
  //   new BrowserTracing({ router }),
  // ],
  tracesSampleRate: Number(process.env.SENTRY_SAMPLE_RATE),  // 環境変数から取得して数値に変換
  environment: process.env.NODE_ENV,
  allowUrls: process.env.NODE_ENV === "production"
    ? ["https://hr-monster.io"]
    : ["http://localhost:8080"]
  // 本番環境では本番のURLを、開発環境ではローカルのURLを許可
  // これにより、開発環境でのエラーもSentryに送信されるようになります
});



// WEBPACK FOOTER //
// ./src/main.js